"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _moment = _interopRequireDefault(require("moment"));
var SelectSingleDateModal = /*#__PURE__*/function (_Vue) {
  function SelectSingleDateModal() {
    var _this;
    (0, _classCallCheck2.default)(this, SelectSingleDateModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, SelectSingleDateModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {
      date: null
    });
    return _this;
  }
  (0, _inherits2.default)(SelectSingleDateModal, _Vue);
  return (0, _createClass2.default)(SelectSingleDateModal, [{
    key: "onSubmitOk",
    value: function onSubmitOk() {
      this.visible = false;
      return (0, _moment.default)(this.form.date).format("YYYY-MM-DD");
    }
  }, {
    key: "handleCreate",
    value: function handleCreate(defaultDate) {
      this.visible = true;
      this.form = {
        date: _moment.default.unix(defaultDate).toDate()
      };
      // this.date = moment.unix(defaultDate).toDate();
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("submitOk")], SelectSingleDateModal.prototype, "onSubmitOk", null);
SelectSingleDateModal = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], SelectSingleDateModal);
var _default = exports.default = SelectSingleDateModal;